import 'twin.macro';
import 'styled-components/macro';
import { shuffle } from 'lodash';
import { Link } from 'react-router-dom';

import { useFavoritesContext } from 'toy/context/Favorites';
import { FavoritesSuggest } from 'toy/molecules/favorites-suggest/FavoritesSuggest';
import { SweetCardItem } from 'toy/molecules/sweet-card/SweetCard';
import { useSweetsQuery } from 'types/graphql-toy';

import { ButtonV2 } from '../../../component-lib/atoms/button-v2/ButtonV2';
import { EmptyPlaceholder } from '../../../component-lib/molecules/placeholder/EmptyPlaceholder';
import { BackButton } from '../../atoms/back-button/BackButton';
import { useShoppingCartContext } from '../../context/ShoppingCart';
import { CartTable } from '../../molecules/cart-table/CartTable';

const ShoppingCart = () => {
  const { cartItems, cartItemsCount, removeFromCart, clearCart } = useShoppingCartContext();
  const { loading: favoritesLoading, data: sweetsData } = useSweetsQuery();
  const { items } = useFavoritesContext();

  const suggestItems = shuffle(
    items
      .filter(itemId => !cartItems.some(cartItem => cartItem.item.id === itemId))
      .map(itemId => sweetsData?.sweets?.find(({ id }) => id === itemId))
      .filter((item): item is SweetCardItem => !!item),
  );

  return (
    <>
      <div tw="flex justify-between">
        <h1 tw="display-1 mb-2">Cart</h1>
        <BackButton />
      </div>

      {cartItemsCount ? (
        <>
          <CartTable items={cartItems} removeFromCart={removeFromCart} />
          <div tw="text-right mt-3">
            <ButtonV2 onClick={clearCart}>Clear cart</ButtonV2>
          </div>
        </>
      ) : (
        <EmptyPlaceholder
          title="You don't have any items on the cart yet."
          description="Go back to the sweets list and start adding items to the cart."
          buttons={
            <Link to="/toy-shop/sweet">
              <ButtonV2 variant="primary">Start shopping</ButtonV2>
            </Link>
          }
        />
      )}

      <FavoritesSuggest loading={favoritesLoading} items={suggestItems} />
    </>
  );
};

export default ShoppingCart;
